export default (options) => (vuexStore) => {
  const reducer = options.reducer ? options.reducer : (state) => state
  const lastState = reducer(parse(localStorage.getItem('vonix-settings')))

  let lastJson = JSON.stringify(lastState)

  vuexStore.replaceState(restoreState(vuexStore.state, lastState))

  vuexStore.subscribe((_, state) => {
    const currJson = JSON.stringify(reducer(state))
    if (currJson === lastJson) return
    localStorage.setItem('vonix-settings', currJson)
    lastJson = currJson
  })
}

const restoreState = (state, lastState) => {
  const restored = { ...state }

  for (const [moduleName, moduleState] of Object.entries(lastState)) {
    if (!isObject(moduleState) || !isObject(state[moduleName])) continue
    restored[moduleName] = { ...state[moduleName], ...defined(moduleState) }
  }

  return restored
}

const defined = (source) => (
  Object.fromEntries(Object.entries(source).filter(([, value]) => value !== undefined))
)

const isObject = (val) => Boolean(val) && typeof val === 'object' && !Array.isArray(val)

const parse = (val) => {
  if ([null, undefined, ''].includes(val)) return {}

  try {
    return JSON.parse(val)
  } catch {
    return {}
  }
}
